import { Component } from '@grafikr/components';
import { fromEvent, map, pairwise, startWith, throttleTime } from 'rxjs';

import { NonNullish } from 'utils/nullish-check';

export default Component((node, { app, onMounted }) => {
  const headerGroupElements = Array.from(
    document.querySelectorAll('.shopify-section-group-header-group'),
  );

  const isSticky = node.hasAttribute('data-sticky');
  const isTransparent = node.hasAttribute('data-transparent');
  let isHidden = false;

  const handleMenuBlocks = () => {
    const blocks = node.querySelectorAll<HTMLElement>('[data-menu-block]');

    blocks.forEach((block) => {
      const target = NonNullish(block.dataset.menuBlock);
      const template = node.querySelector<HTMLTemplateElement>(`template[data-target="${target}"]`);

      if (template) {
        block.append(...template.content.children);
      } else {
        block.remove();
      }
    });

    app.mount(node);
  };

  const setHeightProperty = () => {
    document.documentElement.style.setProperty(
      '--header-height',
      !isHidden ? `${node.clientHeight}px` : '0px',
    );
  };

  const handleScroll = () => {
    const threshold =
      headerGroupElements.reduce((acc, current) => acc + current.clientHeight, 0) +
      NonNullish(node.querySelector('[data-main]')).clientHeight;

    fromEvent(window, 'scroll', { passive: true })
      .pipe(
        throttleTime(50),
        map(() => window.scrollY),
        startWith(window.scrollY),
        pairwise(),
        map(([previous, current]) => ({
          shouldHide: current > threshold && current > previous,
          isAboveThreshold: current > threshold,
        })),
      )
      .subscribe(({ shouldHide, isAboveThreshold }) => {
        node.classList.toggle('header--hidden', isSticky && shouldHide);
        node.classList.toggle('header--transparent', isTransparent && !isAboveThreshold);
        isHidden = shouldHide;
        setHeightProperty();
      });
  };

  const handleResize = () => {
    new ResizeObserver(setHeightProperty).observe(node);
  };

  onMounted(() => {
    handleMenuBlocks();
    handleResize();

    if (isSticky) {
      handleScroll();
    }
  });
});
